export default __webpack_public_path__ + "static/media/asset.3ca04cd5.svg";